class LCLogo extends HTMLElement {
  constructor() {
    super();
    this.rootLayer = this.querySelector("[data-root-layer]");
    this.letterEls = this.querySelectorAll("[data-letter]");
  }

  connectedCallback() {
    this.init();
    this.animateWithGSAP();
  }

  animateWithGSAP() {
    // Đảm bảo đã load xong DOM và GSAP từ CDN
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const ScrollSmoother = window.ScrollSmoother;
    const ScrollToPlugin = window.ScrollToPlugin;

    if (!gsap || !ScrollTrigger) {
      console.warn("GSAP hoặc ScrollTrigger chưa được load!");
      return;
    }

    // Đăng ký plugin nếu chưa đăng ký
    if (gsap.registerPlugin) {
      gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
    }

    // Reset vị trí ban đầu
    gsap.set(this.letterEls, { x: 0 });

    // Tạo timeline
    // Khởi tạo một timeline GSAP với ScrollTrigger để đồng bộ hiệu ứng với cuộn trang
    // gsap.timeline({...}): Tạo một timeline để quản lý chuỗi các animation
    // scrollTrigger: Đối tượng cấu hình cho plugin ScrollTrigger
    //   - trigger: Phần tử DOM dùng làm mốc kích hoạt trigger (ở đây là document.body, tức là toàn bộ trang)
    //   - start: "top top" nghĩa là khi đỉnh của trigger (body) chạm đỉnh viewport thì bắt đầu hiệu ứng
    //   - end: "bottom bottom" nghĩa là khi đáy của trigger (body) chạm đáy viewport thì kết thúc hiệu ứng
    //   - scrub: 1 nghĩa là hiệu ứng sẽ đồng bộ mượt mà với thao tác cuộn, giá trị càng lớn thì càng trễ
    //   - markers: true (bị comment) dùng để debug, hiển thị vị trí start/end trên màn hình
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: document.body, // Phần tử làm mốc kích hoạt trigger (toàn bộ trang)
        start: "top top", // Bắt đầu khi đỉnh body chạm đỉnh viewport
        end: "bottom bottom", // Kết thúc khi đáy body chạm đáy viewport
        scrub: 1, // Hiệu ứng đồng bộ với cuộn, mượt mà
        // markers: true,       // Bật để debug vị trí start/end (tùy chọn)
      },
    });
    console.log("Time line: ", tl);

    // Giải thích các hàm và thông số trong đoạn timeline GSAP này:

    // tl.to(target, vars, position)
    // target: phần tử hoặc mảng phần tử sẽ được animate (ở đây là các chữ cái logo)
    // vars: object chứa các thuộc tính sẽ animate, ví dụ { x: -120 } là di chuyển theo trục X -120px
    // position: thời điểm bắt đầu hiệu ứng trong timeline (tính bằng giây hoặc nhãn, ở đây là 0, 0.2, 0.4, ...)

    // Step 1: Tách các chữ cái ra xa nhau
    tl.to(this.letterEls[0], { x: -50 }, 0) // Chữ đầu tiên (O) sang trái 120px
      .to(this.letterEls[1], { x: 0 }, 0) // Chữ thứ 2 (W) giữ nguyên vị trí
      .to(this.letterEls[2], { x: 0 }, 0) // Chữ thứ 3 (I) giữ nguyên vị trí
      .to(this.letterEls[3], { x: 50 }, 0) // Chữ cuối (N) sang phải 120px

      // Step 2: OWI gần nhau, N ở xa phải
      .to(this.letterEls[0], { x: -50 }, 0.6) // O giữ nguyên trái 120px
      .to(this.letterEls[1], { x: -50 }, 0.6) // W dịch sang trái 70px (gần O)
      .to(this.letterEls[2], { x: -50 }, 0.6) // I dịch sang trái 70px (gần W)
      .to(this.letterEls[3], { x: 50 }, 0.6) // N giữ nguyên phải 70px

      // Step 3: O ở xa trái, WIN gần nhau
      .to(this.letterEls[0], { x: -50 }, 1.2) // O giữ nguyên trái 120px
      .to(this.letterEls[1], { x: 50 }, 1.2) // W dịch sang phải 70px (gần I)
      .to(this.letterEls[2], { x: 50 }, 1.2) // I dịch sang phải 70px (gần W)
      .to(this.letterEls[3], { x: 50 }, 1.2) // N giữ nguyên phải 70px

      // Step 4: OW gần nhau, IN gần nhau (OW cách IN)
      .to(this.letterEls[0], { x: -50 }, 1.6) // O giữ nguyên trái 120px
      .to(this.letterEls[1], { x: -50 }, 1.6) // W dịch sang trái 70px (gần O)
      .to(this.letterEls[2], { x: 50 }, 1.6) // I dịch sang phải 70px (gần N)
      .to(this.letterEls[3], { x: 50 }, 1.6) // N giữ nguyên phải 70px

      // Step 5: Về vị trí ban đầu (các chữ cái về lại vị trí gốc, hiệu ứng lần lượt từng chữ với stagger)
      .to(this.letterEls, { x: 0, stagger: 0 }, 2.2);

    // Giải thích thêm:
    // - Các giá trị x: -120, -80, 80, 120 là khoảng cách di chuyển theo trục X (px) của từng chữ cái.
    // - Các mốc thời gian (0, 0.2, 0.4, 0.6, 0.8) là vị trí trong timeline khi hiệu ứng bắt đầu.
    // - stagger: 0.05 nghĩa là mỗi chữ cái sẽ trở về vị trí gốc cách nhau 0.05s, tạo hiệu ứng lần lượt.
  }

  init() {
    try {
      console.log(
        "%c🚀 LC %cLogo Component Initialized\n%c✨ Interactive scroll animations for custom logo letters",
        "color: #FF6B6B; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.3);",
        "color: #4ECDC4; font-size: 14px; font-weight: 600;",
        "color: #95A5A6; font-size: 12px; font-style: italic;"
      );
    } catch (e) {
      console.error(
        "%c🚀 LC %cLogo Component Error\n%c✨ Interactive scroll animations for custom logo letters",
        "color: #FF6B6B; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.3);",
        "color: #4ECDC4; font-size: 14px; font-weight: 600;",
        "color: #95A5A6; font-size: 12px; font-style: italic;"
      );
      console.error(e);
    }
  }
}

customElements.define("lc-logo", LCLogo);
